export default "__VITE_ASSET__Dvz4rOEb__"